// extracted by mini-css-extract-plugin
module.exports = {"block":"Ssfiu-","noPadding":"DURFjy","centered":"OVWnSA","withVerticalSeparator":"xZRX3K","bodyBlock":"o2c_dC","wide":"Y27t7g","isInTab":"JUv5zh","notBlock":"F0crBY"};